import React from 'react';
import { Link } from 'react-router-dom';
import { mockBalance, mockTransactions, mockLinkedCards } from '../data/mockData';
import { TransactionItem } from '../components/TransactionItem';
import { LinkedCardItem } from '../components/LinkedCardItem';
import { Wallet, CreditCard, Plus, ArrowRight, TrendingUp } from 'lucide-react';
export function AccountPage() {
  const recentTransactions = mockTransactions.slice(0, 3);
  const activeCards = mockLinkedCards.filter(card => card.isActive);
  return <div className="min-h-screen bg-gray-50 pb-32 pt-8 px-4 md:px-8" data-id="element-208">
      <div className="max-w-6xl mx-auto" data-id="element-209">
        {/* Header */}
        <div className="mb-10" data-id="element-210">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-3" data-id="element-211">
            Account
          </h1>
          <p className="text-gray-500 text-lg md:text-xl" data-id="element-212">
            Manage your cashback rewards and linked payment cards.
          </p>
        </div>

        {/* Two Column Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-id="element-213">
          {/* Cashback Summary Card */}
          <div className="bg-gradient-to-br from-kithward-700 to-kithward-800 rounded-2xl p-8 text-white shadow-xl" data-id="element-214">
            <div className="flex items-center gap-3 mb-6" data-id="element-215">
              <div className="bg-white/20 p-3 rounded-xl" data-id="element-216">
                <Wallet className="w-6 h-6" data-id="element-217" />
              </div>
              <h2 className="text-2xl font-bold" data-id="element-218">My Cashback</h2>
            </div>

            <div className="space-y-6" data-id="element-219">
              <div data-id="element-220">
                <p className="text-white/80 text-sm mb-2" data-id="element-221">Total Earned</p>
                <p className="text-5xl font-bold" data-id="element-222">
                  ${mockBalance.total.toFixed(2)}
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4 pt-6 border-t border-white/20" data-id="element-223">
                <div data-id="element-224">
                  <p className="text-white/80 text-sm mb-1" data-id="element-225">Available</p>
                  <p className="text-2xl font-bold text-green-300" data-id="element-226">
                    ${mockBalance.available.toFixed(2)}
                  </p>
                </div>
                <div data-id="element-227">
                  <p className="text-white/80 text-sm mb-1" data-id="element-228">Pending</p>
                  <p className="text-2xl font-bold text-amber-300" data-id="element-229">
                    ${mockBalance.pending.toFixed(2)}
                  </p>
                </div>
              </div>

              <Link to="/history" className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-white text-kithward-700 rounded-full font-bold hover:bg-gray-100 transition-colors w-full justify-center" data-id="element-230">
                View All Transactions
                <ArrowRight className="w-5 h-5" data-id="element-231" />
              </Link>
            </div>
          </div>

          {/* Linked Cards Card */}
          <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm" data-id="element-232">
            <div className="flex items-center justify-between mb-6" data-id="element-233">
              <div className="flex items-center gap-3" data-id="element-234">
                <div className="bg-kithward-50 p-3 rounded-xl" data-id="element-235">
                  <CreditCard className="w-6 h-6 text-kithward-700" data-id="element-236" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-237">
                  Linked Cards
                </h2>
              </div>
              <span className="text-sm font-medium text-gray-500" data-id="element-238">
                {activeCards.length} active
              </span>
            </div>

            <div className="space-y-4 mb-6" data-id="element-239">
              {mockLinkedCards.slice(0, 2).map(card => <LinkedCardItem key={card.id} card={card} data-id="element-240" />)}
            </div>

            <Link to="/link-card" className="inline-flex items-center gap-2 px-6 py-3 bg-kithward-700 text-white rounded-full font-bold hover:bg-kithward-800 transition-colors w-full justify-center shadow-md" data-id="element-241">
              <Plus className="w-5 h-5" data-id="element-242" />
              Add New Card
            </Link>

            {mockLinkedCards.length > 2 && <button className="w-full mt-3 text-kithward-700 font-medium hover:underline text-sm" data-id="element-243">
                View all cards ({mockLinkedCards.length})
              </button>}
          </div>
        </div>

        {/* Recent Transactions Section */}
        <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm" data-id="element-244">
          <div className="flex items-center justify-between mb-6" data-id="element-245">
            <div className="flex items-center gap-3" data-id="element-246">
              <div className="bg-green-50 p-3 rounded-xl" data-id="element-247">
                <TrendingUp className="w-6 h-6 text-green-600" data-id="element-248" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-249">
                Recent Transactions
              </h2>
            </div>
            <Link to="/history" className="text-kithward-700 font-medium hover:underline text-sm" data-id="element-250">
              View all
            </Link>
          </div>

          <div className="space-y-3" data-id="element-251">
            {recentTransactions.map(transaction => <TransactionItem key={transaction.id} transaction={transaction} data-id="element-252" />)}
          </div>

          {recentTransactions.length === 0 && <div className="text-center py-12" data-id="element-253">
              <p className="text-gray-500 text-lg mb-4" data-id="element-254">No transactions yet</p>
              <Link to="/explore" className="inline-flex items-center gap-2 text-kithward-700 font-bold hover:underline" data-id="element-255">
                Start shopping to earn cashback
                <ArrowRight className="w-4 h-4" data-id="element-256" />
              </Link>
            </div>}
        </div>
      </div>
    </div>;
}